import React, { useState, useEffect } from 'react';
import styles from '../BasicCleanupsFilter.module.scss';
import { CalciteCheckbox } from '@esri/calcite-components-react';

let checkAll = false;
let hasFirstRender = false;
const BasicHazardWasteFilter = (props) => {
  const [checkboxDivArray, setCheckboxDivArray] = useState<Array<any>>([]);
  const [checkAllCheckbox, setCheckAllCheckbox] = useState<Array<any>>([]);
  const options = {
    "*NPL Superfund": {
      param: "FD_SF_NPL_IND <> 'N' And FD_SF_SITE_ID IS NOT NULL",
      isIncluded: false,
      objectIds: null
    },
    "*Non-NPL Superfund": {
      param: "FD_NON_NPL_STATUS IS NOT NULL And FD_SF_SITE_ID IS NOT NULL",
      isIncluded: false,
      objectIds: null
    },
    "*BRAC": {
      param: "MAP_SYMBOL_CODE LIKE '%F%' AND (FD_BRAC_IND = 'Y')",
      isIncluded: false,
      objectIds: null
    },
    "*RCRA": {
      param: "MAP_SYMBOL_CODE LIKE '%F%' AND (FD_RCRA_CA_IND = 'Y' AND FD_RCRA_HANDLER_ID IS NOT NULL)",
      isIncluded: false,
      objectIds: null
    },
    "Other Docket Facilities": {
      // param: "MAP_SYMBOL_CODE LIKE '%F%' AND ((FD_FF_IND IN ('Y','N') OR FD_FF_IND IS NULL) AND (FD_SF_NPL_IND ='N' OR FD_SF_NPL_IND IS NULL) AND FD_RCRA_HANDLER_ID IS NULL AND FD_BRAC_ROUND IS NULL)",
      param: "MAP_SYMBOL_CODE LIKE '%F%' AND (FD_FF_IND IN ('Y','N') OR FD_FF_IND IS NULL) AND (FD_SF_NPL_IND ='N' OR FD_SF_NPL_IND IS NULL) AND FD_RCRA_HANDLER_ID IS NULL AND FD_BRAC_ROUND IS NULL",
      isIncluded: false,
      objectIds: null
    }
  }

  const toggleAll = () => {
    // switch checkAll
    checkAll = !checkAll;
    for (let option in options) {

      if (checkAll) {
        // set all isIncludeds to false so they can be set to true from buildCheckBoxDivs()
        options[option]["isIncluded"] = false;
      } else if (!checkAll) {
        // switch all isIncludeds to true so they can be switched back to false by toggleParam()
        options[option]["isIncluded"] = true;
        toggleParam(option);
      }
    }
    buildCheckboxDivs();
  }

  const toggleParam = async (key) => {
    options[key].isIncluded = !options[key].isIncluded;
    passUpdatedParams();
  }

  const passUpdatedParams = () => {
    let paramArray: Array<any> = [];
    for (let option in options) {
      if (options[option].isIncluded === true) {
        paramArray.push(options[option].param)
      }
    }
    props.updateFederalHazardWasteParams(paramArray);
  }

  const buildCheckAllCheckboxDiv = () => {
    let checkAllDiv;
    if (!checkAll) {
      checkAllDiv =
        <div className={styles.SectionTitleDivs}>
          <CalciteCheckbox name={"toggleAllHazardWaste"} onCalciteCheckboxChange={() => { toggleAll() }} key={Math.random()} />
          <label className={styles.FilterSectionLabels}>Federal Agency Hazardous Waste Compliance Docket</label>
        </div>;
    } else if (checkAll) {
      checkAllDiv =
        <div className={styles.SectionTitleDivs}>
          <CalciteCheckbox checked name={"toggleAllHazardWaste"} onCalciteCheckboxChange={() => { toggleAll() }} key={Math.random()} />
          <label className={styles.FilterSectionLabels}>Federal Agency Hazardous Waste Compliance Docket</label>
        </div>;
      // toggleAll();
    }
    setCheckAllCheckbox(checkAllDiv);
  }

  const buildCheckboxDivs = () => {
    let tempArr: Array<any> = [];
    if (!checkAll) {
      for (let key in options) {
        tempArr.push(
          <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
            <CalciteCheckbox name={options[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(key) }} />
            <label className={styles.CheckboxLabels}>{key}</label>
          </div>
        );
      }
    } else if (checkAll) {
      for (let key in options) {
        toggleParam(key);
        tempArr.push(
          <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
            <CalciteCheckbox checked name={options[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(key) }} />
            <label className={styles.CheckboxLabels}>{key}</label>
          </div>
        );
      }
    }
    setCheckboxDivArray(tempArr);
  }


  useEffect(() => { }, [checkboxDivArray]);

  useEffect(() => {
    if (props.checkAllBoxes === true) {
      checkAll = true;
    } else if (props.checkAllBoxes === false || props.checkAllBoxes === undefined) {
      if (props.customRouteUsed && hasFirstRender === false) {
        checkAll = true;
        hasFirstRender = true;
        buildCheckAllCheckboxDiv();
        buildCheckboxDivs();
        props.updateDefinitionExpression();
        return;
      } else {
        checkAll = false;
      }
    }
    buildCheckAllCheckboxDiv();
    buildCheckboxDivs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.signalAChange]);



  return (
    <div className={styles.Sections}>
      {checkAllCheckbox}
      <div className={styles.CheckboxSectionDivs}>
        {checkboxDivArray}
      </div>
    </div>
  );

}

export default BasicHazardWasteFilter;
